export default __webpack_public_path__ + "static/media/frame.3add8805.svg";